module.exports = __webpack_public_path__ + "static/img/foodstuff@2x.e0b610d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logisticsBigData/foodstuff@2x.png
// module id = hx67
// module chunks = 44